// extracted by mini-css-extract-plugin
export default {"field":"InformationEdit_field__GcbDA","text":"InformationEdit_text__9Q6-S"};